// src/components/UserWidget.tsx
import React from 'react';
import { useTelegramWebApp } from '../hooks/useTelegramWebApp';
import { getEmail } from '../utils/token';

const UserWidget: React.FC = () => {
  const raw = getEmail() || '';
  const user = raw.split('@')[0];
  console.log('User data:', user);
  
  // Формируем отображаемое имя
  const getDisplayName = () => {
    if (!user) return 'Guest';
    
    if (user) {
      return `${user}`;
    }
    
    if (user) {
      return `${user}`;
    }
    
    if (user) {
      return user;
    }
    
    return 'Telegram User';
  };

  // Получаем URL аватарки пользователя
  const getAvatarUrl = () => {
    if (user) {
      return user;
    }
    
    // Если фото не установлено, используем заглушку
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(getDisplayName())}&background=3B82F6&color=ffffff&size=60`;
  };

  return (
    <div style={{ position: 'relative', width: 1345, height: 119 }}>
      {/* ---------- username ---------- */}
      <div
        style={{
          position: 'absolute',
          left: 1046,
          top: 72,
          width: 223,
          height: 29,
          fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
          fontWeight: 510,
          fontSize: 24,
          lineHeight: '29px',
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 0.8)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {getDisplayName()}
      </div>

      {/* ---------- внешний градиентный круг ---------- */}
      <div
        style={{
          position: 'absolute',
          left: 1281,
          top: 55,
          width: 63.9,
          height: 63.9,
          borderRadius: '50%',
          background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
          mixBlendMode: 'normal',
          boxShadow: `
            -9.03182px -8.41752px 38.88px -9.72px rgba(0,0,0,.15),
            -1.5053px -1.40292px 9.72px -6.48px rgba(0,0,0,.15),
            inset 1.73863px 1.62037px 7.4844px rgba(255,255,255,.126),
            inset 0.985974px 0.918913px 3.7422px rgba(255,255,255,.126)
          `,
          backdropFilter: 'blur(6.1398px)',
          WebkitBackdropFilter: 'blur(6.1398px)',
        }}
      />

      {/* ---------- внутренний круг-аватар ---------- */}
      <div
        style={{
          position: 'absolute',
          left: 1284.6,
          top: 58.6,
          width: 56.7,
          height: 56.7,
          borderRadius: '50%',
          background: `url(${getAvatarUrl()})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          mixBlendMode: 'normal',
          boxShadow: `
            -9.03182px -8.41752px 38.88px -9.72px rgba(0,0,0,.15),
            -1.5053px -1.40292px 9.72px -6.48px rgba(0,0,0,.15),
            inset 1.73863px 1.62037px 7.4844px rgba(255,255,255,.126),
            inset 0.985974px 0.918913px 3.7422px rgba(255,255,255,.126)
          `,
          backdropFilter: 'blur(6.1398px)',
          WebkitBackdropFilter: 'blur(6.1398px)',
        }}
      />
    </div>
  );
};

export default UserWidget;